// extracted by mini-css-extract-plugin
export var wrapper = "Copyright-module--wrapper--60036";
export var layout = "Copyright-module--layout--dce3f";
export var captcha = "Copyright-module--captcha--b9cdf";